import { observer } from "mobx-react";
import React from "react";
import { BotsAdminStore } from "../../stores/admin/BotsAdminStore";
import BootstrapTable from "react-bootstrap-table-next";
import { Pager } from "../utils/Pager";
import moment from "moment";
import { IconButton } from "@mui/material";
import { observable } from "mobx";
import { Alert, FormGroup, InputGroup } from "@blueprintjs/core";
import ReactJson from "react-json-view";
import { MDBBtn, MDBCol, MDBRow } from "mdbreact";
import { DateRangePicker30 } from "../utils/DateRangePicker30";
import { debounce } from "underscore";
import { formatCpfOrCnpj } from "../../utils";
import { AppIcon } from "../utils/AppIcon";
import LoadingModal from "../loading/LoadingModal";

interface state {

  date1: string,
  date2: string

}

@observer
export class SefaErrosPage extends React.Component<{}, state> {

  obs = observable({
    open_detalhes: false as boolean,
    open_solicitacao: false as boolean,
    loading: false as boolean,
    tarefa: {} as any,
    fetchOptions: {} as any,

    current_page: 1 as number,
    filter_periodo: [] as any,
    filter_cnpj: "" as string,
    filter_erro: "" as string,
  })

  constructor(props) {
    super(props);

    this.state = {
      date1: "",
      date2: ""
    }

    this.obs.fetchOptions = debounce(this.handleBusca.bind(this), 800);

  }

  /** 
   * Retorna o período correspondente ao mês atual. 
   * 
   * @returns Objeto contendo o intervalo de datas para o componente 
   * e as datas inicial e final no formato YYYY-MM-DD. 
   */
  getPeriodoMesAtual = () => {
    const inicio = moment().startOf("month");
    const fim = moment().endOf("month");

    return {
      periodo: [inicio.toDate(), fim.toDate()],
      date1: inicio.format("YYYY-MM-DD"),
      date2: fim.format("YYYY-MM-DD")
    };
  };

  /** 
   * Inicializa a página utilizando o período do mês atual 
   * e carrega a primeira página dos erros da SEFA. 
   * 
   * @returns {Promise<void>} 
   */
  async componentDidMount(): Promise<void> {

    this.obs.loading = true

    const periodo = this.getPeriodoMesAtual();

    this.setState({ date1: periodo.date1, date2: periodo.date2 }, async () => {

      this.obs.filter_periodo = periodo.periodo;

      await BotsAdminStore.handleIndexSefaErros(
        this.obs.current_page,
        this.obs.filter_cnpj,
        periodo.date1,
        periodo.date2,
        this.obs.filter_erro,
      )

    })

    this.obs.loading = false

  }

  /** 
   * Altera a página atual e carrega os registros correspondentes. 
   * 
   * @param page Número da página que será carregada. 
   * @returns {Promise<void>} 
   */
  async handlePageChange(page) {

    this.obs.current_page = page

    if (this.state.date1 == "Data inválida") return
    if (this.state.date2 == "Data inválida") return

    await BotsAdminStore.handleIndexSefaErros(
      page,
      this.obs.filter_cnpj,
      this.state.date1,
      this.state.date2,
      this.obs.filter_erro,
    )

  }

  /** 
   * Realiza uma nova busca utilizando os filtros informados. 
   * 
   * Reinicia a paginação para a primeira página antes de carregar os registros. 
   * 
   * @returns {Promise<void>} 
   */
  async handleBusca() {

    this.obs.current_page = 1

    if (this.state.date1 == "Data inválida") return
    if (this.state.date2 == "Data inválida") return

    this.obs.loading = true

    await BotsAdminStore.handleIndexSefaErros(
      1,
      this.obs.filter_cnpj,
      this.state.date1,
      this.state.date2,
      this.obs.filter_erro,
    )

    this.obs.loading = false

  }

  /**
   * Abre o modal com os detalhes completos do erro selecionado. 
   * 
   * @param row Registro do erro selecionado na tabela. 
   * @returns {Promise<void>} 
   */
  async handleViewDetalhes(row) {

    this.obs.tarefa = row

    this.obs.open_detalhes = true

  }

  /** 
   * Busca e exibe os dados da solicitação vinculada ao erro. 
   * 
   * @param row Registro do erro contendo o identificador da solicitação. 
   * @returns {Promise<void>} 
   */
  async handleViewSolicitacao(row) {

    let resp = await BotsAdminStore.handleIndexSefaSolicitacao(row.solicitacao_id)

    this.obs.tarefa = resp

    this.obs.open_solicitacao = true

  }

  /** 
   * Renderiza o botão utilizado para visualizar os detalhes do erro. 
   * 
   * @param row Registro correspondente à linha da tabela. 
   * @returns Botão de visualização dos detalhes.
   */
  formatDetalhes = (row) => {
    return (<IconButton onClick={(e) => this.handleViewDetalhes(row)}>
      <img src="/images/view.png" width="18px" />
    </IconButton>);
  }

  /**
   * Renderiza o botão utilizado para visualizar a solicitação vinculada ao erro. 
   * 
   * @param row Registro correspondente à linha da tabela. 
   * @returns Botão de visualização da solicitação. 
   */
  formatSolicitacao = (row) => {
    return (<IconButton onClick={(e) => this.handleViewSolicitacao(row)}>
      <AppIcon size={18} name="search" style={{ color: "#3579ea" }} />
    </IconButton>);
  }

  /** 
   * Formata a data de criação do registro. 
   * 
   * @param inserted_at Data de criação recebida pela API. 
   * @returns Data formatada como DD/MM/YYYY HH:mm ou "-" quando ausente. 
   */
  formatDate = (inserted_at) => {

    if (!inserted_at) return "-"

    const date = new Date(inserted_at);

    return moment.utc(date).format("DD/MM/YYYY HH:mm");

  };

  /** 
   * Atualiza o período selecionado e executa uma nova busca. 
   * 
   * @param val Intervalo de datas selecionado no componente. 
   * @returns {void}
   */
  handleDateChange = (val: any) => {
    var string = val.toString();

    var array = string.split(",");

    this.setState({
      date1: moment(array[0]).format("YYYY-MM-DD"),
      date2: moment(array[1]).format("YYYY-MM-DD")
    }, () => {

      if (moment(array[0]).format("YYYY-MM-DD") == "Data inválida") {
        this.setState({ date1: "" });
      }

      if (moment(array[1]).format("YYYY-MM-DD") == "Data inválida") {
        this.setState({ date2: "" });
      }

      this.obs.fetchOptions()

    });

    this.obs.filter_periodo = val;

  };

  render() {

    const columns = [
      {
        dataField: "solicitacao_id",
        text: "Solicitação ID",
        headerStyle: { width: "170px" },
      },
      {
        dataField: "razao_social",
        text: "Razão Social",
        headerStyle: { minWidth: "220px" },
      },
      {
        dataField: "cnpj",
        text: "CNPJ",
        formatter: (cell, row) => formatCpfOrCnpj(row.cnpj),
        headerStyle: { width: "150px" },
      },
      {
        dataField: "inserted_at",
        text: "Criado em",
        formatter: (cell, row) => this.formatDate(row.inserted_at),
        headerStyle: { width: "150px" },
      },
      {
        dataField: "erro",
        text: "Erro",
        headerStyle: { minWidth: "350px" },
        style: {
          whiteSpace: "normal",
          wordBreak: "break-word",
        },
      },
      {
        dataField: "detalhes",
        text: "Detalhes",
        formatter: (cell, row) => this.formatDetalhes(row),
        headerStyle: {
          width: "70px",
          textAlign: "center",
        },
        style: {
          textAlign: "center",
        },
      },
      {
        dataField: "solicitacao",
        text: "Solicitação",
        formatter: (cell, row) => this.formatSolicitacao(row),
        headerStyle: {
          width: "80px",
          textAlign: "center",
        },
        style: {
          textAlign: "center",
        },
      },
    ];

    return (
      <div>

        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 15,
            alignItems: 'flex-end',
          }}
        >
          <FormGroup label="CNPJ" style={{ flex: '1 1 220px', minWidth: 220 }}>
            <InputGroup
              placeholder="Digite o CNPJ"
              value={this.obs.filter_cnpj}
              onChange={(e) => { this.obs.filter_cnpj = e.target.value; this.obs.fetchOptions() }}
              fill
            />
          </FormGroup>

          <FormGroup label="Período" className="inputsPeriodoCalculos" style={{ flex: '1 1 220px', minWidth: 220 }}>
            <DateRangePicker30
              onChange={this.handleDateChange}
              value={this.obs.filter_periodo}
              disabled={false}
            />
          </FormGroup>

          <FormGroup label="Erro" style={{ flex: '1 1 220px', minWidth: 220 }}>
            <InputGroup
              placeholder="Digite o Erro"
              value={this.obs.filter_erro}
              onChange={(e) => { this.obs.filter_erro = e.target.value; this.obs.fetchOptions() }}
              fill
            />
          </FormGroup>

          <FormGroup style={{ flex: '0 0 auto' }}>
            <MDBBtn
              className="btnDefault btnBuscarNfe filtroFullWidth"
              onClick={() => this.handlePageChange(1)}
              style={{ marginBottom: 2 }}
              disabled={this.obs.loading}
            >
              Buscar
            </MDBBtn>
          </FormGroup>

        </div>

        {/* @ts-ignore */}
        <BootstrapTable keyField="_id" data={BotsAdminStore.obs.sefa_erros} columns={columns} wrapperClasses="TableDefault tabela-excesso" />

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.current_page}
            totalCount={BotsAdminStore.obs.length_sefa_erros}
            pageSize={20}
            onPageChange={page => this.handlePageChange(page)}
          />
        </div>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.open_detalhes}
          onClose={() => this.obs.open_detalhes = false}
          canOutsideClickCancel={true}
          intent="primary"
        >
          <h2 className="titleSEFAZ">Detalhes</h2>

          <div className="heightResposta">
            <ReactJson collapsed={false} displayDataTypes={false} src={this.obs.tarefa} />
          </div>

        </Alert>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.open_solicitacao}
          onClose={() => this.obs.open_solicitacao = false}
          canOutsideClickCancel={true}
          intent="primary"
        >
          <h2 className="titleSEFAZ">Solicitação</h2>

          <div className="heightResposta">
            <ReactJson collapsed={false} displayDataTypes={false} src={this.obs.tarefa} />
          </div>

        </Alert>

        <LoadingModal open={this.obs.loading} onClose={() => this.obs.loading = false} title={"Carregando"} />

      </div>
    );

  }

}
